<app-search-document-grid
    [option]="docSelectBoxOption"
    (appFormValue)="addDoc($event)"
></app-search-document-grid>
